<!-- 入场列表组件-->
<template>
<div>
    <el-form ref="elForm"  size="medium" label-width="120px">
        <el-form-item label="告警日期" prop="dd">
            <el-date-picker v-model="listQuery.entryTime" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
            </el-date-picker>
        </el-form-item>
        <el-form-item size="large">
            <el-button size="small" class="filter-item" type="primary" icon="search" @click="getList">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
        </el-form-item>
    </el-form>
    <el-table :data="list" v-loading="listLoading" size="small" stripe highlight-current-row>
        <el-table-column property="truckNo" label="车牌号"></el-table-column>
        <el-table-column property="entryTime" label="入场时间"></el-table-column>
        <el-table-column property="oilEdequipmentCode" label="撬装编号"></el-table-column>
        <el-table-column property="" label="监管状态">
            <template slot-scope="scope">{{scope.row.isSupervise==true?'监管':"未监管" }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
                <el-link type="success" @click="handleClick(scope.row)">查看抓拍图片</el-link>
            </template>
        </el-table-column>
    </el-table>
    <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
    </div>

    <el-dialog title="抓拍预览" :visible.sync="imagePreviewVisible" :modal="false">
        <img :src="previewImageUrl" style="width:100%;" />
    </el-dialog>

</div>
</template>

<script>
import {
    page,
    getObj
} from '@/api/admin/sysOilTankTruckin'
import {
    mapGetters
} from 'vuex';
import templet from '../templet.vue';
export default {
    components: {
        templet
    },
    name: 'truckInComponents',
    props: {
        carNo: {
            type: String,
            required: false,
            default: ""
        }
    },
    data() {
        return {
            listQuery: {
                page: 1,
                limit: 10,
                truckNo: "",
                entryTime: [],
            },
            listLoading: false,
            list: [],
            total: 0,
            imagePreviewVisible: false,
            previewImageUrl: true,
        }
    },
    created() {
        this.listQuery.truckNo = this.carNo;
        this.getList()
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        getList() {
            let self = this;
            this.listLoading = true;
            let query = {
                ...this.listQuery
            };
            query.entryTime = JSON.stringify(query.entryTime);
            page(query).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        handleClick(row) {
            getObj(row.oilid)
                .then(response => {
                    let extJson = response.extJson
                    if (extJson) {
                        let enterImageArray = JSON.parse(extJson).enterImageArray;
                        if (enterImageArray && enterImageArray.length > 0) {
                            let url = enterImageArray[0].carImage;
                            if (url) {
                                this.imagePreviewVisible = true;
                                this.previewImageUrl = url;
                            }
                        }

                    }
                });
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        resetForm(){
            this.listQuery={
                page: 1,
                limit: 10,
                truckNo: "",
                entryTime: [],
            }
        },
        pickerOptions: {
            disabledDate(time) {
                return time.getTime() > Date.now();
            },
            shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近一个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近三个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                }
            }]
        }
    }
}
</script>

<style scoped>

</style>
